/**
 * Copy and rules for the ATS ExpoData API toolkit (`ats_api`), shared by the
 * per-conference form and the reusable-config create/edit forms. Use it for an
 * ATS show that is "ID-only": the badge QR is just the badge ID, and the
 * record is looked up at ATS. A show whose badges carry the encrypted record
 * uses `ats` instead. The username and password are the API login in ATS's
 * developer-kit email, stored as secrets; ATS's hosts are fixed on the server.
 */

/** Same rule as the server: the password must not have leading or trailing spaces. */
export const ATS_API_PASSWORD_RULE = {
  validator: (_: unknown, v?: string) =>
    !v || v === v.trim() ? Promise.resolve() : Promise.reject(new Error('Password has leading or trailing spaces')),
};

/** Same rule as the server: 1 to 12 digits; surrounding spaces are trimmed on save. */
export const ATS_API_SHOW_ID_RULE = {
  pattern: /^\s*[0-9]{1,12}\s*$/,
  message: 'Show ID must be 1 to 12 digits',
};

/** Same rule as the server: the login is sent as HTTP Basic auth. */
export const ATS_API_USERNAME_RULE = {
  validator: (_: unknown, v?: string) =>
    !v || /^[^\s:]+$/.test(v)
      ? Promise.resolve()
      : Promise.reject(new Error('Username must not contain spaces, line breaks or a colon')),
};

export const ATS_API_SHOW_ID_EXTRA =
  "ATS's numeric show ID for this event (ATS lists it for the developer-kit login). Use ats_api only when ATS says the event is ID-only; for encrypted ATS badges use ats.";

export const ATS_API_SECRETS_EXTRA =
  "The API username and password from ATS's developer-kit email. Never paste these into Slack or a shared doc.";
